import React from 'react';
import styled from 'styled-components';

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 14px;
`;

const Label = styled.label`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11.5px;
  font-weight: 700;
  color: #475569;
  letter-spacing: 0.3px;
  text-transform: uppercase;
`;

const InputField = styled.input`
  width: 100%;
  padding: 11px 14px;
  font-size: 14.5px;
  font-weight: 500;
  color: #1e293b;
  background: #ffffff;
  border: 1px solid ${props => props.error ? '#EF4444' : 'rgba(148, 163, 184, 0.28)'};
  border-radius: 11px;
  box-shadow:
    0 1px 0 rgba(255, 255, 255, 0.9) inset,
    0 1px 2px rgba(15, 23, 42, 0.04);
  transition:
    border-color 160ms ease,
    box-shadow 160ms ease,
    background 160ms ease;

  &:hover:not(:disabled):not(:focus) {
    border-color: ${props => props.error ? '#EF4444' : 'rgba(148, 163, 184, 0.45)'};
  }

  &:focus {
    outline: none;
    border-color: ${props => props.error ? '#EF4444' : '#4FB3BF'};
    box-shadow:
      0 1px 0 rgba(255, 255, 255, 0.9) inset,
      0 0 0 3px ${props => props.error ? 'rgba(239, 68, 68, 0.18)' : 'rgba(79, 179, 191, 0.22)'};
  }

  &:disabled {
    background: #f8fafc;
    color: #94a3b8;
    cursor: not-allowed;
  }

  &::placeholder {
    color: #94a3b8;
    font-weight: 500;
  }
`;

const TextArea = styled.textarea`
  width: 100%;
  padding: 11px 14px;
  font-size: 14.5px;
  font-weight: 500;
  color: #1e293b;
  background: #ffffff;
  border: 1px solid ${props => props.error ? '#EF4444' : 'rgba(148, 163, 184, 0.28)'};
  border-radius: 11px;
  resize: vertical;
  min-height: 90px;
  font-family: inherit;
  box-shadow:
    0 1px 0 rgba(255, 255, 255, 0.9) inset,
    0 1px 2px rgba(15, 23, 42, 0.04);
  transition:
    border-color 160ms ease,
    box-shadow 160ms ease;

  &:hover:not(:disabled):not(:focus) {
    border-color: ${props => props.error ? '#EF4444' : 'rgba(148, 163, 184, 0.45)'};
  }

  &:focus {
    outline: none;
    border-color: ${props => props.error ? '#EF4444' : '#4FB3BF'};
    box-shadow:
      0 1px 0 rgba(255, 255, 255, 0.9) inset,
      0 0 0 3px ${props => props.error ? 'rgba(239, 68, 68, 0.18)' : 'rgba(79, 179, 191, 0.22)'};
  }

  &:disabled {
    background: #f8fafc;
    color: #94a3b8;
    cursor: not-allowed;
  }

  &::placeholder {
    color: #94a3b8;
    font-weight: 500;
  }
`;

const ErrorMessage = styled.span`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 600;
  color: #DC2626;
  padding-left: 2px;

  &::before {
    content: '⚠';
    font-size: 11px;
  }
`;

export const Input = ({ label, error, ...props }) => {
  return (
    <InputWrapper>
      {label && <Label htmlFor={props.id}>{label}</Label>}
      <InputField error={error} {...props} />
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </InputWrapper>
  );
};

export const Textarea = ({ label, error, ...props }) => {
  return (
    <InputWrapper>
      {label && <Label htmlFor={props.id}>{label}</Label>}
      <TextArea error={error} {...props} />
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </InputWrapper>
  );
};
